import { render, staticRenderFns } from "./ShippingBatchesTable.vue?vue&type=template&id=77f73aab&"
import script from "./ShippingBatchesTable.vue?vue&type=script&lang=js&"
export * from "./ShippingBatchesTable.vue?vue&type=script&lang=js&"
import style0 from "./ShippingBatchesTable.vue?vue&type=style&index=0&id=77f73aab&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports